import { create } from 'zustand';
import type { AccountBlockCode } from '@/lib/accountStatus/types';

/**
 * Drives the account-blocked screen (CP-007b). Opened by the 403 interceptor
 * when the server reports the account is closed (SUSPENDED) or locked (BANNED).
 * The block is server-enforced and can't be cleared in-session, so there's no
 * replay — the gate just surfaces the screen and the original 403 propagates.
 */
interface AccountStatusGateState {
  open: boolean;
  code: AccountBlockCode | null;
  openGate: (code: AccountBlockCode) => void;
  close: () => void;
}

const useAccountStatusGateStore = create<AccountStatusGateState>((set) => ({
  open: false,
  code: null,
  openGate: (code) => set({ open: true, code }),
  close: () => set({ open: false, code: null }),
}));

export const useAccountStatusGateOpen = () => useAccountStatusGateStore((s) => s.open);
export const useAccountStatusGateCode = () => useAccountStatusGateStore((s) => s.code);
export const useCloseAccountStatusGate = () => useAccountStatusGateStore((s) => s.close);

/** Non-hook accessor for the 403 interceptor (outside React). */
export const openAccountStatusGateImperative = (code: AccountBlockCode) =>
  useAccountStatusGateStore.getState().openGate(code);
